import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ManualInboundCallAlertState {
    show: boolean;
    incomingCallAlertText?: string;
}

@Injectable({
    providedIn: 'root',
})
export class HeaderService {

    private countdownField = new BehaviorSubject<string>('');
    countdownField$ = this.countdownField.asObservable();

     setCountdownField(value: string) {
        this.countdownField.next(value);
    }

    private manualInboundCallAlertSubject = new BehaviorSubject<ManualInboundCallAlertState>({
        show: false,
        incomingCallAlertText: '',
    });
    manualInboundCallAlert$ = this.manualInboundCallAlertSubject.asObservable();

    setManualInboundCallAlert(state: ManualInboundCallAlertState) {
        this.manualInboundCallAlertSubject.next(state);
    }

    private answerInboundCallSubject = new Subject<void>();
    answerInboundCall$ = this.answerInboundCallSubject.asObservable();

    private rejectInboundCallSubject = new Subject<void>();
    rejectInboundCall$ = this.rejectInboundCallSubject.asObservable();

    triggerAnswerInboundCall(val) {
        this.answerInboundCallSubject.next(val);
    }

    triggerRejectInboundCall(val) {
        this.rejectInboundCallSubject.next(val);
    }
}